import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/molecules/Form";
import * as React from "react";
import { useFormContext } from "react-hook-form";
import { Checkbox, CheckboxProps } from "./Checkbox";

export type CheckboxFieldProps = CheckboxProps & {
  name: string;
  checkboxClassName?: string;
  label?: React.ReactNode;
  subcopy?: React.ReactNode;
  description?: React.ReactNode;
  note?: React.ReactNode;
  readOnly?: boolean;
};

export const CheckboxField = ({
  className,
  checkboxClassName,
  label,
  subcopy,
  description,
  note,
  name,
  readOnly,
  ...checkboxProps
}: CheckboxFieldProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem
          disabled={checkboxProps.disabled}
          readOnly={readOnly}
          className={className}
        >
          {!!label && (
            <FormLabel subcopy={subcopy} required={checkboxProps.required}>
              {label}
            </FormLabel>
          )}
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
              className={checkboxClassName}
              description={description}
              {...checkboxProps}
              {...field}
            />
          </FormControl>
          <FormMessage className="tw-pl-24 !tw-mt-0">{note}</FormMessage>
        </FormItem>
      )}
    />
  );
};
CheckboxField.displayName = "CheckboxField";
